import {Room} from '../models/room';

export const ROOMS: Room[] = [
	{id: 1, name: 'Jungfrau'},
	{id: 2, name: 'Jägerhorn'},
	{id: 3, name: 'Dufourspitze'},
	{id: 4, name: 'Mönch'},
	{id: 5, name: 'Eiger'},
	{id: 6, name: 'Matterhorn'},
	{id: 7, name: 'Dom'},
	{id: 8, name: 'Munot'},
	{id: 9, name: 'Titlis'},
	{id: 10, name: 'Reiat'},
	{id: 11, name: 'Hörnli'},
	{id: 12, name: 'Bachtel'},
	{id: 13, name: 'Chrüzegg'},
	{id: 14, name: 'Schnebelhorn'},
	{id: 15, name: 'Schauenberg'},
	{id: 16, name: 'Zimmerberg 1'},
	{id: 17, name: 'Zimmerberg 2'},
	{id: 18, name: 'Käferberg'},
	{id: 19, name: 'Etzel'},
	{id: 20, name: 'Schönenberg'},
	{id: 21, name: 'Zürichberg'},
	{id: 22, name: 'Felsenegg'},
	{id: 23, name: 'Hönggerberg'},
	{id: 24, name: 'Altberg'}
];
